// extracted by mini-css-extract-plugin
export var arrow = "br_dF";
export var profile = "br_dD";
export var text = "br_dv";